import React, {forwardRef, useState} from 'react';
import house_placeholder from "../Images/house_placeholder.png";
import { Button } from "react-bootstrap";
import COLORS from "../Helpers/utils";
import LabelTag from "./LabelTagComponent";
import {useNavigate} from "react-router-dom";
import noReception from "../Images/no_reception.png"
import {BuildingSummary} from "../types/protocols";
import {colorForBuildingType, nameForBuildingType} from "../types/BuildingTypeEnums";
import {placeholderForBuildingType} from "../Helpers/PlaceholderUtils";

interface BuildingListItemProps {
    building: BuildingSummary;
    highlighted: boolean;
    onClick: (id: string) => void;
}

const BuildingListItem = forwardRef<HTMLLIElement, BuildingListItemProps>(
    ({ building, highlighted, onClick }, ref) => {
        const navigate = useNavigate();
        const handleClick = () => {
            navigate(`/building/${building.key}`);
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
            <li
                ref={ref}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    display: 'flex',
                    alignItems: 'stretch',
                    paddingRight: '1rem',
                    cursor: 'pointer',
                }}
                onClick={() => onClick(building.name!)}
            >
                <div
                    style={{
                        backgroundColor: highlighted ? COLORS.primaryDark : 'transparent',
                        width: '0.4rem',
                        borderRadius: '1rem',
                        marginRight: '0.3rem',
                        marginLeft: '0.3rem',
                    }}
                />

                {/* White main card on the right */}
                <div
                    style={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        padding: '1rem',
                        boxShadow: highlighted || isHovered ? '0 2px 4px rgba(0, 0, 0, 0.4)' : '0 2px 4px rgba(0, 0, 0, 0.1)',
                        flex: 1,
                    }}
                >
                    <div style={{
                        position: 'absolute',
                        top: '1rem',
                        right: '1rem',
                        display: 'flex',
                        gap: '0.5rem'
                    }}>
                        {
                            building.buildingInfo?.hasPoorReception &&
                            <img
                                src={noReception}
                                alt="No reception"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                }}
                            />
                        }
                        <img
                            src={building.coverPhoto?.smallSizeUrl || placeholderForBuildingType(building.buildingType)}
                            alt="Building"
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                        />
                    </div>
                    <div style={{ textAlign: 'left', marginRight: '90px' }}>
                        <LabelTag text={nameForBuildingType(building.buildingType).toUpperCase()} backgroundColor={colorForBuildingType(building.buildingType)}/>
                        <br/>
                        {
                            building.groupTags &&
                            Object.values(building.groupTags).map((tag)=> {
                                return <LabelTag text={tag.tag} backgroundColor={COLORS.redOrange}/>
                            })
                        }
                        <strong style={{
                            marginTop: '5px',
                            fontSize: '12pt',
                            display: 'block',
                            marginBottom: '0rem',
                        }}>
                            {building.name}
                        </strong>
                        <span style={{
                            fontSize: '12pt',
                            color: '#444444',
                            display: 'block',
                        }}>
                            <div style={{ marginBottom: '-0.2rem' }}>Reservat: {building.locationCategories?.category2?.name}</div>
                            <div>Län: {building.locationCategories?.category1?.name}</div>
                        </span>
                        <Button
                            className={"small-button-style"}
                            style={{marginTop: '30px'}}
                            variant="secondary"
                            onClick={handleClick} >
                            ÖPPNA
                        </Button>
                    </div>
                </div>
            </li>
        );
    }
);

export default BuildingListItem;